"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobState = void 0;
const class_transformer_1 = require("class-transformer");
const typeorm_1 = require("typeorm");
const job_1 = require("./job");
const contact_1 = require("./contact");
const user_role_enum_1 = require("./user-role-enum");
let JobState = class JobState {
};
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
    }),
    __metadata("design:type", Number)
], JobState.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => job_1.Job),
    (0, typeorm_1.JoinColumn)({ name: 'job_api_id', referencedColumnName: 'apiId' }),
    __metadata("design:type", job_1.Job)
], JobState.prototype, "job", void 0);
__decorate([
    (0, class_transformer_1.Expose)({
        groups: [`role:${user_role_enum_1.UserRoleEnum.ADMIN}`],
    }),
    (0, typeorm_1.Column)({
        type: 'jsonb',
    }),
    __metadata("design:type", Object)
], JobState.prototype, "state", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_1.Contact, { onDelete: 'SET NULL', onUpdate: 'CASCADE' }),
    __metadata("design:type", contact_1.Contact)
], JobState.prototype, "contact", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
    }),
    __metadata("design:type", Array)
], JobState.prototype, "statuses", void 0);
__decorate([
    (0, typeorm_1.Column)({
        default: true,
    }),
    __metadata("design:type", Boolean)
], JobState.prototype, "archived", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    __metadata("design:type", Date)
], JobState.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    __metadata("design:type", Date)
], JobState.prototype, "updatedAt", void 0);
JobState = __decorate([
    (0, typeorm_1.Entity)()
], JobState);
exports.JobState = JobState;
//# sourceMappingURL=job-state.js.map